import React from "react";

const operationsDetailMarkup = String.raw`<div class="card inline-style-33" id="opsDetailPanel">
<div class="card-head"><p class="card-title" id="opsDetailTitle">Detail</p><span class="reset-tag" onclick="opsCloseDetail()">Close ✕</span></div>
<div id="opsDetailBody"></div>
</div>`;

export default function OperationsDetailDrilldown() {
  return (
    <div
      className="raw-fragment"
      dangerouslySetInnerHTML={{ __html: operationsDetailMarkup }}
    />
  );
}